
import React from 'react';
import { motion } from 'framer-motion';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';
import { FaSearch, FaDraftingCompass, FaRocket } from 'react-icons/fa';
import './Approach.css';

const Approach = () => {
    const [ref, isVisible] = useIntersectionObserver();

    const steps = [
        {
            icon: <FaSearch />,
            title: "Diagnose",
            desc: "We assess organizational health to identify root causes, not symptoms."
        },
        {
            icon: <FaDraftingCompass />,
            title: "Design",
            desc: "We convert strategic intent into clear systems, structures, and execution-ready roadmaps."
        },
        {
            icon: <FaRocket />,
            title: "Deliver",
            desc: "We ensure disciplined execution through clear ownership, governance, and continuous tracking."
        }
    ];

    return (
        <section className="approach-section section" ref={ref} id="approach">
            <div className="container">
                <div className="approach-layout">
                    <motion.div
                        className="approach-text-content"
                        initial="initial"
                        animate={isVisible ? "animate" : "initial"}
                        variants={fadeInUp}
                    >
                        <h3 className="section-title-italic">The Triology Approach</h3>
                        <h4 className="section-subtitle">From ambiguity to aligned execution</h4>
                        <p className="section-desc">Our consulting approach follows a structured journey</p>
                    </motion.div>

                    <motion.div
                        className="approach-grid"
                        variants={staggerContainer}
                        initial="initial"
                        animate={isVisible ? "animate" : "initial"}
                    >
                        {steps.map((step, index) => (
                            <motion.div key={index} className="approach-card" variants={staggerItem}>
                                <div className="approach-icon-wrapper">
                                    {step.icon}
                                </div>
                                <div className="approach-card-content">
                                    <h3 className="approach-card-title">{step.title}</h3>
                                    <p className="approach-card-desc">{step.desc}</p>
                                </div>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>

                <motion.div
                    className="approach-footer"
                    initial={{ opacity: 0 }}
                    animate={isVisible ? { opacity: 1 } : {}}
                    transition={{ delay: 0.5 }}
                >
                    <p>This approach reduces execution risk and builds internal capability.</p>
                </motion.div>
            </div>
        </section>
    );
};

export default Approach;
